define('CartToQuote.Button.View', [
    'SCView',
    'carttoquote_button_view.tpl',
    'underscore'
], function CartToQuoteButtonViewDefinition(
    SCViewComponent,
    cartToQuoteButtonViewTpl,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    var CartToQuoteButtonView = function CartToQuoteButtonView(options) {
        SCView.call(this);

        this.template = cartToQuoteButtonViewTpl;
        this.options = options || {};
        this.configuration = this.options.configuration;
        this.attributes = {
            id: 'CartToQuoteButtonView',
            'class': 'CartToQuoteButton-View'
        };
    };

    // Inherit parent instance methods.
    CartToQuoteButtonView.prototype = Object.create(SCView.prototype);

    // Restore the constuctor.
    CartToQuoteButtonView.prototype.constructor = CartToQuoteButtonView;

    CartToQuoteButtonView.prototype.getTitle = function getTitle() {
        return _(this.options.pageInfo.title).translate();
    };

    CartToQuoteButtonView.prototype.getContext = function getContext() {
        return {
            hashtag: '#' + this.options.pageInfo.fragment,
            buttonLabel: this.configuration.cartButtonLabel || this.getTitle()
        };
    };

    // Return the AMD constructor.
    return CartToQuoteButtonView;
});
